export const colors = {
	Grants: { slug: "#F99BEF", bar: "#643E93" },
	Publications: { slug: "#FAD51F", bar: "#64553F" },
	Patents: { slug: "#436BF5", bar: "#1B2B95" },
	Investments: { slug: "#E95B40", bar: "#5D244D" },
};
